module.exports = __webpack_public_path__ + "media/images/banners/2-755b1068d8286c6e0b6633d259625976.jpg";